/**
 * Runtime configuration. Loaded from window.__ADMIN_CONFIG__ injected by
 * /config.js at deploy time. Falls back to dev defaults so `npm run dev`
 * works out of the box.
 */
export interface AdminConfig {
  /** Base URL of the tenant-mgmt HTTP API (no trailing slash). */
  apiBaseUrl: string;
  /** Base URL del flow-engine HTTP API. */
  apiBaseUrlFlow: string;
  /** #155: Base URL del reporting-api (dashboard, reports, exports). */
  apiBaseUrlReporting: string;
  /** Cognito hosted UI domain (no trailing slash). Ej: https://zen-dev-auth.auth.us-east-2.amazoncognito.com */
  cognitoDomain: string;
  /** Cognito user pool client ID. */
  cognitoClientId: string;
  /** Callback URL registered in Cognito for this SPA. */
  redirectUri: string;
  /** Logout URL Cognito should redirect to after logout. */
  logoutUri: string;
  /** Widget bundle URL used by the WidgetPreview iframe. */
  widgetBundleUrl: string;
  /** Environment label, shown in the topbar. */
  envLabel: string;
}

declare global {
  interface Window {
    __ADMIN_CONFIG__?: Partial<AdminConfig>;
  }
}

const defaults: AdminConfig = {
  apiBaseUrl: 'http://localhost:3000',
  apiBaseUrlFlow: 'http://localhost:3000',
  apiBaseUrlReporting: 'http://localhost:3000',
  cognitoDomain: 'https://zen-dev-auth.auth.us-east-2.amazoncognito.com',
  cognitoClientId: '4mr4vrvcvklm81m8gp2mb2eb72',
  redirectUri: `${window.location.origin}/callback`,
  logoutUri: window.location.origin,
  widgetBundleUrl: '/widget.js',
  envLabel: 'dev',
};

export const config: AdminConfig = {
  ...defaults,
  ...(window.__ADMIN_CONFIG__ ?? {}),
};
